export default {
      id: "checkmark-usage",
      viewBox: "0 0 216 146",
      url: __webpack_public_path__ + "icons.svg#checkmark",
      toString: function () {
        return this.url;
      }
    }